export default __webpack_public_path__ + "static/media/HospitalCardBg.52cdfb8b.svg";